import { useEffect } from 'react';
const PIXEL_ID = '1497337765421439';
const SCRIPT_ID = 'meta-pixel-script';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) {
      window.fbq?.('track', 'PageView');
      return;
    }

    /* Meta Pixel Code */
    const fbq: NonNullable<Window['fbq']> = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue?.push(args);
      }
    };
    window.fbq = fbq;
    if (!window._fbq) {
      window._fbq = fbq;
    }
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-154" data-mp="13j1hmgzl6pkk">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-155" data-mp="1ido6vqkrq61g" />
    </noscript>;
}